import { CustomAttributeDataType } from '../../../types';
import { InternalCustomAttribute, InternalCustomAttributeType } from './types';

export const mapClientToServerType: {
  [key in CustomAttributeDataType]: Pick<InternalCustomAttribute, 'multipleChoice' | 'type'>;
} = {
  date: {
    type: InternalCustomAttributeType.Date,
  },
  numeric: {
    type: InternalCustomAttributeType.Numeric,
  },
  text: {
    type: InternalCustomAttributeType.Text,
  },
  select: {
    multipleChoice: false,
    type: InternalCustomAttributeType.Text,
  },
  multi_select: {
    multipleChoice: true,
    type: InternalCustomAttributeType.Text,
  },
};
